/**
 * Tenant Detail Page
 * ==================
 * صفحة تفاصيل الشركة الشاملة - ربط كامل بقاعدة البيانات
 */

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../../../lib/ui/Button';
import { Modal } from '../../../lib/ui/Modal';
import { Input } from '../../../lib/ui/Input';
import { tenantsService, tenantManagementService } from '../../services/api';
import { useToast } from '../../context/ToastContext';
import SAR from '../../../components/SAR';
import './TenantDetailPage.css';

const I = {
  back: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>,
  edit: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  trash: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>,
  users: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  orders: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/></svg>,
  revenue: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  drivers: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
  info: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>,
  settings: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  check: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>,
  x: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  key: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>,
  mapPin: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  ship: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/><path d="M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76"/><path d="M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"/></svg>,
  car: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a1 1 0 0 0-.8-.4H5.24a2 2 0 0 0-1.8 1.1l-.8 1.63A6 6 0 0 0 2 12.42V16h2"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/></svg>,
  dollar: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  tag: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>,
  chart: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  download: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  plus: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  refresh: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>,
};

// ==========================================
// Helper: Status Badge
// ==========================================
const StatusBadge = ({ active, activeText = 'نشط', inactiveText = 'معطل' }) => (
  <span className={`td-badge ${active ? 'td-badge--green' : 'td-badge--red'}`}>
    <span className="td-badge__dot" />
    {active ? activeText : inactiveText}
  </span>
);

// ==========================================
// Helper: Data Table component
// ==========================================
const DataTable = ({ columns, rows, loading: tLoading, emptyIcon, emptyText }) => {
  if (tLoading) {
    return <div className="td-table-empty"><div className="watrly-admin-loading__spinner" /></div>;
  }
  if (!rows || rows.length === 0) {
    return (
      <div className="td-table-empty">
        <span className="td-table-empty__icon">{emptyIcon}</span>
        <p>{emptyText || 'لا توجد بيانات'}</p>
      </div>
    );
  }
  return (
    <div className="td-table-wrapper">
      <table className="td-table">
        <thead>
          <tr>{columns.map((col, i) => <th key={i}>{col.label}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((row, ri) => (
            <tr key={row.id || ri}>
              {columns.map((col, ci) => (
                <td key={ci}>{col.render ? col.render(row) : row[col.key] || '-'}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// ==========================================
// Main Component
// ==========================================
const TenantDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();

  // Core data
  const [loading, setLoading] = useState(true);
  const [tenant, setTenant] = useState(null);
  const [stats, setStats] = useState({});
  const [users, setUsers] = useState([]);
  const [activeTab, setActiveTab] = useState('info');

  // Management tab data
  const [tabData, setTabData] = useState([]);
  const [tabTotal, setTabTotal] = useState(0);
  const [tabLoading, setTabLoading] = useState(false);

  // Reports overview
  const [reportStats, setReportStats] = useState(null);
  const [reportPeriod, setReportPeriod] = useState('30d');

  // Modals
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);
  const [userFormData, setUserFormData] = useState({});
  const [passwordData, setPasswordData] = useState({ password: '', confirmPassword: '' });
  const [saving, setSaving] = useState(false);

  // Ship review modals
  const [shipApprove, setShipApprove] = useState(null);
  const [shipReject, setShipReject]   = useState(null);
  const [shipNotes, setShipNotes]     = useState('');
  const [shipReason, setShipReason]   = useState('');
  const [actioning, setActioning]     = useState(false);

  // Driver modal
  const [showDriverModal, setShowDriverModal] = useState(false);
  const [driverForm, setDriverForm] = useState({ full_name: '', phone: '', national_id: '' });
  const [driverResult, setDriverResult] = useState(null);

  // Vehicle modal
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [vehicleForm, setVehicleForm] = useState({ plate_number: '', plate_letters: '', make: '', model: '', capacity_tons: '' });

  // ─── Load tenant core data ───
  const loadTenantData = useCallback(async () => {
    setLoading(true);
    try {
      const [tenantData, statsData, usersData] = await Promise.all([
        tenantsService.getById(id).catch(() => null),
        tenantsService.getStats(id).catch(() => ({})),
        tenantsService.getUsers(id).catch(() => ({ items: [] })),
      ]);
      if (tenantData) {
        setTenant(tenantData);
        setEditData({
          name: tenantData.name,
          slug: tenantData.slug,
          plan_code: tenantData.plan_code,
          timezone: tenantData.timezone || 'Asia/Riyadh',
          default_currency_code: tenantData.default_currency_code || 'SAR',
          status: tenantData.status,
          contact_phone: tenantData.contact_phone || tenantData.phone || '',
          contact_email: tenantData.contact_email || tenantData.email || '',
          city: tenantData.city || '',
          region: tenantData.region || '',
          country: tenantData.country || 'السعودية',
          address: tenantData.address || '',
          commercial_registration: tenantData.commercial_registration || '',
          vat_number: tenantData.vat_number || '',
          bank_name: tenantData.bank_name || '',
          bank_account: tenantData.bank_account || '',
          iban: tenantData.iban || '',
          commission_rate: tenantData.commission_rate ?? '',
          monthly_fee: tenantData.monthly_fee ?? '',
          tax_rate: tenantData.tax_rate ?? 15,
          price_per_km: tenantData.price_per_km ?? '',
          price_per_15min: tenantData.price_per_15min ?? '',
          max_service_distance_km: tenantData.max_service_distance_km ?? '',
        });
      }
      setStats(statsData);
      setUsers(usersData.items || usersData || []);
    } catch (error) {
      console.error('Failed to load tenant:', error);
      toast.error('فشل في تحميل بيانات الشركة');
    } finally {
      setLoading(false);
    }
  }, [id]);

  // ─── Load tab-specific data from DB via API ───
  const loadTabData = useCallback(async () => {
    const managementTabs = ['branches', 'ships', 'drivers', 'vehicles', 'pricing', 'coupons'];
    if (!managementTabs.includes(activeTab)) return;

    setTabLoading(true);
    try {
      const fetchMap = {
        branches: () => tenantManagementService.getBranches(id, { page: 1, page_size: 50 }),
        ships:    () => tenantManagementService.getShips(id, { page: 1, page_size: 50 }),
        drivers:  () => tenantManagementService.getDrivers(id, { page: 1, page_size: 50 }),
        vehicles: () => tenantManagementService.getVehicles(id, { page: 1, page_size: 50 }),
        pricing:  () => tenantManagementService.getPricing(id, { page: 1, page_size: 50 }),
        coupons:  () => tenantManagementService.getCoupons(id, { page: 1, page_size: 50 }),
      };

      const result = await fetchMap[activeTab]();
      setTabData(result.items || []);
      setTabTotal(result.total || 0);
    } catch (error) {
      console.error(`Failed to load ${activeTab}:`, error);
      setTabData([]);
      setTabTotal(0);
    } finally {
      setTabLoading(false);
    }
  }, [activeTab, id]);

  // ─── Load report stats from DB ───
  const loadReportStats = useCallback(async () => {
    if (activeTab !== 'reports') return;
    setTabLoading(true);
    try {
      const data = await tenantManagementService.getStatsOverview(id, reportPeriod);
      setReportStats(data);
    } catch (error) {
      console.error('Failed to load report stats:', error);
      setReportStats(null);
    } finally {
      setTabLoading(false);
    }
  }, [activeTab, id, reportPeriod]);

  useEffect(() => { loadTenantData(); }, [loadTenantData]);
  useEffect(() => { loadTabData(); }, [loadTabData]);
  useEffect(() => { loadReportStats(); }, [loadReportStats]);

  // ─── Export report from DB ───
  const handleExportReport = async (reportType) => {
    try {
      toast.info(`جاري تصدير تقرير ${reportType}...`);
      const result = await tenantManagementService.exportStats(id, {
        report_type: reportType,
        period: 'monthly',
        format: 'json'
      });
      toast.success(`تم تصدير ${result.count || 0} سجل بنجاح`);
    } catch (error) {
      toast.error('فشل تصدير التقرير');
    }
  };

  // ─── Tenant actions (all via API → DB) ───
  const handleToggleStatus = async () => {
    try {
      if (tenant.status === 'active') {
        await tenantsService.suspend(id);
        toast.success('تم تعليق الشركة');
      } else {
        await tenantsService.activate(id);
        toast.success('تم تفعيل الشركة');
      }
      loadTenantData();
    } catch (error) {
      toast.error('فشل تحديث حالة الشركة');
    }
  };

  const handleUpdateTenant = async () => {
    setSaving(true);
    try {
      const changedFields = {};
      Object.keys(editData).forEach(key => {
        if (editData[key] !== tenant[key]) changedFields[key] = editData[key];
      });
      if (Object.keys(changedFields).length === 0) {
        toast.info('لا توجد تغييرات');
        setShowEditModal(false);
        setSaving(false);
        return;
      }
      await tenantsService.update(id, changedFields);
      toast.success('تم تحديث بيانات الشركة');
      setShowEditModal(false);
      loadTenantData();
    } catch (error) {
      toast.error('فشل تحديث بيانات الشركة');
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteTenant = async () => {
    setSaving(true);
    try {
      await tenantsService.delete(id);
      toast.success('تم حذف الشركة');
      navigate('/admin/tenants');
    } catch (error) {
      toast.error('فشل حذف الشركة');
    } finally {
      setSaving(false);
    }
  };

  // ─── User CRUD (all via API → DB) ───
  const handleEditUser = (user) => {
    setSelectedUser(user);
    setUserFormData({ full_name: user.full_name || '', email: user.email || '', phone: user.phone || '', status: user.status || 'active' });
    setShowUserModal(true);
  };

  const handleUpdateUser = async () => {
    if (!selectedUser) return;
    setSaving(true);
    try {
      const { usersService } = await import('../../services/api');
      await usersService.update(selectedUser.id, userFormData);
      toast.success('تم تحديث بيانات المستخدم');
      setShowUserModal(false);
      setSelectedUser(null);
      loadTenantData();
    } catch (error) {
      toast.error('فشل تحديث بيانات المستخدم');
    } finally {
      setSaving(false);
    }
  };

  const handleChangePassword = (user) => {
    setSelectedUser(user);
    setPasswordData({ password: '', confirmPassword: '' });
    setShowPasswordModal(true);
  };

  const handleUpdatePassword = async () => {
    if (!selectedUser) return;
    if (passwordData.password !== passwordData.confirmPassword) { toast.error('كلمات المرور غير متطابقة'); return; }
    if (passwordData.password.length < 6) { toast.error('كلمة المرور يجب أن تكون 6 أحرف على الأقل'); return; }
    setSaving(true);
    try {
      const { usersService } = await import('../../services/api');
      await usersService.update(selectedUser.id, { password: passwordData.password });
      toast.success('تم تغيير كلمة المرور');
      setShowPasswordModal(false);
      setSelectedUser(null);
    } catch (error) {
      toast.error('فشل تغيير كلمة المرور');
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteUserClick = (user) => { setSelectedUser(user); setShowDeleteUserModal(true); };

  const handleDeleteUser = async () => {
    if (!selectedUser) return;
    setSaving(true);
    try {
      const { usersService } = await import('../../services/api');
      await usersService.delete(selectedUser.id);
      toast.success('تم حذف المستخدم');
      setShowDeleteUserModal(false);
      setSelectedUser(null);
      loadTenantData();
    } catch (error) {
      toast.error('فشل حذف المستخدم');
    } finally {
      setSaving(false);
    }
  };

  // ─── Ship review handlers ───
  const handleApproveShip = async () => {
    if (!shipApprove) return;
    setActioning(true);
    try {
      await tenantManagementService.approveShip(id, shipApprove.id, shipNotes);
      toast.success(`تم قبول الشيب "${shipApprove.name}"`);
      setShipApprove(null); setShipNotes('');
      loadTabData();
    } catch { toast.error('فشل القبول'); }
    finally { setActioning(false); }
  };

  const handleRejectShip = async () => {
    if (!shipReject || !shipReason.trim()) { toast.error('أدخل سبب الرفض'); return; }
    setActioning(true);
    try {
      await tenantManagementService.rejectShip(id, shipReject.id, shipReason);
      toast.success(`تم رفض الشيب "${shipReject.name}"`);
      setShipReject(null); setShipReason('');
      loadTabData();
    } catch { toast.error('فشل الرفض'); }
    finally { setActioning(false); }
  };

  // ─── Driver handlers ───
  const handleCreateDriver = async () => {
    if (!driverForm.full_name || !driverForm.phone) { toast.error('الاسم والهاتف مطلوبان'); return; }
    setSaving(true);
    try {
      const res = await tenantManagementService.createDriver(id, driverForm);
      setDriverResult(res);
      setDriverForm({ full_name: '', phone: '', national_id: '' });
      toast.success('تم إضافة السائق');
      loadTabData();
    } catch { toast.error('فشل إضافة السائق'); }
    finally { setSaving(false); }
  };

  const handleDeleteDriver = async (driverId, name) => {
    if (!window.confirm(`تأكيد إلغاء تفعيل السائق "${name}"؟`)) return;
    try {
      await tenantManagementService.deleteDriver(id, driverId);
      toast.success('تم إلغاء تفعيل السائق');
      loadTabData();
    } catch { toast.error('فشل الحذف'); }
  };

  // ─── Vehicle handlers ───
  const handleCreateVehicle = async () => {
    if (!vehicleForm.plate_number) { toast.error('رقم اللوحة مطلوب'); return; }
    setSaving(true);
    try {
      await tenantManagementService.createVehicle(id, vehicleForm);
      setVehicleForm({ plate_number: '', plate_letters: '', make: '', model: '', capacity_tons: '' });
      setShowVehicleModal(false);
      toast.success('تم إضافة المركبة');
      loadTabData();
    } catch { toast.error('فشل إضافة المركبة'); }
    finally { setSaving(false); }
  };

  const handleDeleteVehicle = async (vehicleId, plate) => {
    if (!window.confirm(`تأكيد إلغاء تفعيل المركبة "${plate}"؟`)) return;
    try {
      await tenantManagementService.deleteVehicle(id, vehicleId);
      toast.success('تم إلغاء تفعيل المركبة');
      loadTabData();
    } catch { toast.error('فشل الحذف'); }
  };

  // ─── Formatters ───
  const Money = ({ n }) => <>{new Intl.NumberFormat('ar-SA').format(n || 0)}{' '}<SAR className="h-[0.8em] w-auto" /></>;
  const formatDate = (d) => d ? new Date(d).toLocaleDateString('ar-SA', { year: 'numeric', month: 'short', day: 'numeric' }) : '-';
  const formatNum = (n) => new Intl.NumberFormat('ar-SA').format(n || 0);

  // ─── Tab definitions ───
  const tabs = [
    { id: 'info',     label: 'معلومات',     icon: I.info },
    { id: 'users',    label: 'المستخدمين',  icon: I.users },
    { id: 'branches', label: 'الفروع',      icon: I.mapPin },
    { id: 'ships',    label: 'الأشياب',     icon: I.ship },
    { id: 'drivers',  label: 'السائقين',    icon: I.drivers },
    { id: 'vehicles', label: 'المركبات',    icon: I.car },
    { id: 'pricing',  label: 'التسعير',     icon: I.dollar },
    { id: 'coupons',  label: 'الكوبونات',   icon: I.tag },
    { id: 'reports',  label: 'التقارير',    icon: I.chart },
    { id: 'settings', label: 'الإعدادات',   icon: I.settings },
  ];

  // ─── Loading / Not Found ───
  if (loading) return <div className="watrly-admin-loading"><div className="watrly-admin-loading__spinner" /></div>;
  if (!tenant) return (
    <div className="watrly-tenant-detail">
      <div className="td-table-empty"><p>لم يتم العثور على الشركة</p><Button onClick={() => navigate('/admin/tenants')}>العودة للقائمة</Button></div>
    </div>
  );

  // ==========================================
  // RENDER
  // ==========================================
  return (
    <div className="watrly-tenant-detail">

      {/* ── Header ── */}
      <div className="watrly-tenant-detail__header">
        <div className="watrly-tenant-detail__header-info">
          <Button variant="ghost" size="sm" onClick={() => navigate('/admin/tenants')}>{I.back}</Button>
          <div className="watrly-tenant-detail__avatar">{tenant.name?.charAt(0) || 'ش'}</div>
          <div className="watrly-tenant-detail__title-group">
            <h1>{tenant.name}</h1>
            <div className="watrly-tenant-detail__meta">
              <StatusBadge active={tenant.status === 'active'} activeText="نشط" inactiveText="معلق" />
              <span>الباقة: {tenant.plan_code === 'enterprise' ? 'مؤسسات' : tenant.plan_code === 'business' ? 'أعمال' : 'أساسي'}</span>
              <span>منذ {formatDate(tenant.created_at)}</span>
            </div>
          </div>
        </div>
        <div className="watrly-tenant-detail__header-actions">
          <Button variant="ghost" onClick={() => setShowEditModal(true)}>{I.edit} تعديل</Button>
          <Button variant={tenant.status === 'active' ? 'warning' : 'success'} onClick={handleToggleStatus}>
            {tenant.status === 'active' ? I.x : I.check}
            {tenant.status === 'active' ? 'تعليق' : 'تفعيل'}
          </Button>
          <Button variant="danger" onClick={() => setShowDeleteModal(true)}>{I.trash} حذف</Button>
        </div>
      </div>

      {/* ── Stats Cards ── */}
      <div className="watrly-tenant-detail__stats">
        {[
          { icon: I.users, value: formatNum(stats.users_count), label: 'المستخدمين', variant: 'primary' },
          { icon: I.orders, value: formatNum(stats.orders_count), label: 'تم التوصيل', variant: 'success' },
          { icon: I.drivers, value: formatNum(stats.drivers_count), label: 'السائقين', variant: 'warning' },
          { icon: I.revenue, value: <Money n={stats.revenue} />, label: 'الإيرادات', variant: 'info' },
        ].map((s, i) => (
          <div key={i} className="watrly-tenant-detail__stat-card">
            <div className={`watrly-tenant-detail__stat-icon watrly-tenant-detail__stat-icon--${s.variant}`}>{s.icon}</div>
            <div className="watrly-tenant-detail__stat-content">
              <span className="watrly-tenant-detail__stat-value">{s.value}</span>
              <span className="watrly-tenant-detail__stat-label">{s.label}</span>
            </div>
          </div>
        ))}
      </div>

      {/* ── Tabs ── */}
      <div className="watrly-tenant-detail__tabs">
        {tabs.map(tab => (
          <button key={tab.id} className={`watrly-tenant-detail__tab ${activeTab === tab.id ? 'watrly-tenant-detail__tab--active' : ''}`} onClick={() => setActiveTab(tab.id)}>
            {tab.icon}{tab.label}
          </button>
        ))}
      </div>

      {/* ════════════════════════ TAB: INFO ════════════════════════ */}
      {activeTab === 'info' && (
        <div className="watrly-tenant-detail__section">
          <div className="watrly-tenant-detail__section-header">
            <h3 className="watrly-tenant-detail__section-title">المعلومات الأساسية</h3>
            <Button variant="ghost" size="sm" onClick={() => setShowEditModal(true)}>{I.edit} تعديل</Button>
          </div>
          <div className="watrly-tenant-detail__section-content">
            <div style={{marginBottom:'1.5rem'}}>
              <h4 style={{color:'#6366F1',marginBottom:'0.75rem',fontSize:'0.85rem',textTransform:'uppercase',letterSpacing:'0.05em'}}>البيانات الأساسية</h4>
              <div className="watrly-tenant-detail__info-grid">
                {[
                  { label: 'اسم الشركة', value: tenant.name },
                  { label: 'المعرف (Slug)', value: tenant.slug },
                  { label: 'الباقة', value: tenant.plan_code === 'enterprise' ? 'مؤسسات' : tenant.plan_code === 'business' ? 'أعمال' : 'أساسي' },
                  { label: 'الحالة', value: tenant.status === 'active' ? 'نشط' : 'معلق' },
                  { label: 'المنطقة الزمنية', value: tenant.timezone || 'Asia/Riyadh' },
                  { label: 'العملة', value: tenant.default_currency_code || 'SAR' },
                  { label: 'تاريخ الإنشاء', value: formatDate(tenant.created_at) },
                  { label: 'آخر تحديث', value: formatDate(tenant.updated_at) },
                ].map((item, i) => (
                  <div key={i} className="watrly-tenant-detail__info-item">
                    <span className="watrly-tenant-detail__info-label">{item.label}</span>
                    <span className="watrly-tenant-detail__info-value">{item.value || '-'}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={{marginBottom:'1.5rem'}}>
              <h4 style={{color:'#10B981',marginBottom:'0.75rem',fontSize:'0.85rem',textTransform:'uppercase',letterSpacing:'0.05em'}}>بيانات التواصل والعنوان</h4>
              <div className="watrly-tenant-detail__info-grid">
                {[
                  { label: 'رقم التواصل', value: tenant.contact_phone || tenant.phone },
                  { label: 'البريد الإلكتروني', value: tenant.contact_email || tenant.email },
                  { label: 'المدينة', value: tenant.city },
                  { label: 'المنطقة', value: tenant.region },
                  { label: 'الدولة', value: tenant.country || 'السعودية' },
                  { label: 'العنوان', value: tenant.address },
                ].map((item, i) => (
                  <div key={i} className="watrly-tenant-detail__info-item">
                    <span className="watrly-tenant-detail__info-label">{item.label}</span>
                    <span className="watrly-tenant-detail__info-value">{item.value || '-'}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={{marginBottom:'1.5rem'}}>
              <h4 style={{color:'#F59E0B',marginBottom:'0.75rem',fontSize:'0.85rem',textTransform:'uppercase',letterSpacing:'0.05em'}}>البيانات التجارية والمالية</h4>
              <div className="watrly-tenant-detail__info-grid">
                {[
                  { label: 'السجل التجاري', value: tenant.commercial_registration },
                  { label: 'الرقم الضريبي (VAT)', value: tenant.vat_number },
                  { label: 'اسم البنك', value: tenant.bank_name },
                  { label: 'رقم الحساب', value: tenant.bank_account },
                  { label: 'IBAN', value: tenant.iban },
                  { label: 'نسبة العمولة', value: tenant.commission_rate != null ? `${tenant.commission_rate}%` : '-' },
                  { label: 'الرسوم الشهرية', value: tenant.monthly_fee != null ? `${tenant.monthly_fee} SAR` : '-' },
                  { label: 'ضريبة القيمة المضافة', value: tenant.tax_rate != null ? `${tenant.tax_rate}%` : '-' },
                ].map((item, i) => (
                  <div key={i} className="watrly-tenant-detail__info-item">
                    <span className="watrly-tenant-detail__info-label">{item.label}</span>
                    <span className="watrly-tenant-detail__info-value">{item.value || '-'}</span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <h4 style={{color:'#8B5CF6',marginBottom:'0.75rem',fontSize:'0.85rem',textTransform:'uppercase',letterSpacing:'0.05em'}}>الاشتراك والتسعير</h4>
              <div className="watrly-tenant-detail__info-grid">
                {[
                  { label: 'بداية الاشتراك', value: tenant.subscription_start_date ? formatDate(tenant.subscription_start_date) : '-' },
                  { label: 'نهاية الاشتراك', value: tenant.subscription_end_date ? formatDate(tenant.subscription_end_date) : '-' },
                  { label: 'سعر/كم', value: tenant.price_per_km != null ? `${tenant.price_per_km} SAR` : '-' },
                  { label: 'سعر/15 دقيقة', value: tenant.price_per_15min != null ? `${tenant.price_per_15min} SAR` : '-' },
                  { label: 'أقصى مسافة خدمة', value: tenant.max_service_distance_km != null ? `${tenant.max_service_distance_km} كم` : '-' },
                ].map((item, i) => (
                  <div key={i} className="watrly-tenant-detail__info-item">
                    <span className="watrly-tenant-detail__info-label">{item.label}</span>
                    <span className="watrly-tenant-detail__info-value">{item.value || '-'}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ════════════════════════ TAB: USERS ════════════════════════ */}
      {activeTab === 'users' && (
        <div className="watrly-tenant-detail__section">
          <div className="watrly-tenant-detail__section-header">
            <h3 className="watrly-tenant-detail__section-title">{I.users} المستخدمين <span className="td-count">{users.length}</span></h3>
          </div>
          <div className="watrly-tenant-detail__section-content">
            <DataTable
              loading={false}
              rows={users}
              emptyIcon={I.users}
              emptyText="لا يوجد مستخدمين حالياً"
              columns={[
                { label: 'المستخدم', render: (u) => (
                  <div className="td-cell-user">
                    <div className="td-cell-avatar">{u.full_name?.charAt(0) || 'م'}</div>
                    <div><strong>{u.full_name}</strong><br /><span className="td-cell-sub">{u.email}</span></div>
                  </div>
                )},
                { label: 'الهاتف', render: (u) => u.phone || '-' },
                { label: 'الأدوار', render: (u) => (u.roles || []).map(r => r.name).join(', ') || '-' },
                { label: 'الحالة', render: (u) => <StatusBadge active={u.status === 'active' || u.is_active} /> },
                { label: 'إجراءات', render: (u) => (
                  <div className="td-cell-actions">
                    <button className="td-action-btn" title="تعديل" onClick={() => handleEditUser(u)}>{I.edit}</button>
                    <button className="td-action-btn" title="كلمة المرور" onClick={() => handleChangePassword(u)}>{I.key}</button>
                    <button className="td-action-btn td-action-btn--danger" title="حذف" onClick={() => handleDeleteUserClick(u)}>{I.trash}</button>
                  </div>
                )},
              ]}
            />
          </div>
        </div>
      )}

      {/* ════════════════════════ TAB: BRANCHES ════════════════════════ */}
      {activeTab === 'branches' && (
        <div className="watrly-tenant-detail__section">
          <div className="watrly-tenant-detail__section-header">
            <h3 className="watrly-tenant-detail__section-title">{I.mapPin} الفروع <span className="td-count">{tabTotal}</span></h3>
            <Button variant="ghost" size="sm" onClick={loadTabData}>{I.refresh}</Button>
          </div>
          <div className="watrly-tenant-detail__section-content">
            <DataTable
              loading={tabLoading}
              rows={tabData}
              emptyIcon={I.mapPin}
              emptyText="لا توجد فروع حالياً"
              columns={[
                { label: 'اسم الفرع', render: (b) => (
                  <div className="td-cell-user">
                    <div className="td-cell-avatar td-cell-avatar--green">{I.mapPin}</div>
                    <div><strong>{b.name}</strong><br /><span className="td-cell-sub">{b.city || '-'}</span></div>
                  </div>
                )},
                { label: 'المنطقة', key: 'region' },
                { label: 'الأشياب', render: (b) => formatNum(b.ships_count) },
                { label: 'الموظفين', render: (b) => formatNum(b.employees_count) },
                { label: 'الحالة', render: (b) => <StatusBadge active={b.is_active} /> },
              ]}
            />
          </div>
        </div>
      )}

      {/* ════════════════════════ TAB: SHIPS ════════════════════════ */}
      {activeTab === 'ships' && (
        <div className="watrly-tenant-detail__section">
          <div className="watrly-tenant-detail__section-header">
            <h3 className="watrly-tenant-detail__section-title">{I.ship} الأشياب <span className="td-count">{tabTotal}</span></h3>
            <Button variant="ghost" size="sm" onClick={loadTabData}>{I.refresh}</Button>
          </div>
          <div className="watrly-tenant-detail__section-content">
            <DataTable
              loading={tabLoading}
              rows={tabData}
              emptyIcon={I.ship}
              emptyText="لا توجد أشياب حالياً"
              columns={[
                { label: 'الشيب', render: (s) => (
                  <div className="td-cell-user">
                    <div className="td-cell-avatar td-cell-avatar--blue">{I.ship}</div>
                    <div><strong>{s.name_ar || s.name}</strong><br /><span className="td-cell-sub">كود: {s.ship_code || s.code || '-'}</span></div>
                  </div>
                )},
                { label: 'الفرع', render: (s) => s.branch_name || '-' },
                { label: 'الطلبات', render: (s) => formatNum(s.orders_count) },
                { label: 'الإيرادات', render: (s) => <span className="td-cell-money"><Money n={s.total_revenue} /></span> },
                { label: 'المراجعة', render: (s) => {
                  const ap = s.approval_status || 'pending';
                  const cls = ap === 'approved' ? 'td-review--green' : ap === 'rejected' ? 'td-review--red' : 'td-review--yellow';
                  const lbl = ap === 'approved' ? 'مقبول' : ap === 'rejected' ? 'مرفوض' : 'قيد المراجعة';
                  return <span className={`td-review-badge ${cls}`}>{lbl}</span>;
                }},
                { label: 'إجراء', render: (s) => (
                  <div className="td-cell-actions">
                    {s.approval_status !== 'approved' && (
                      <button className="td-action-btn td-action-btn--approve" title="قبول"
                        onClick={() => { setShipApprove(s); setShipNotes(''); }}>
                        {I.check}
                      </button>
                    )}
                    {s.approval_status !== 'rejected' && (
                      <button className="td-action-btn td-action-btn--danger" title="رفض"
                        onClick={() => { setShipReject(s); setShipReason(''); }}>
                        {I.x}
                      </button>
                    )}
                  </div>
                )},
              ]}
            />
          </div>
        </div>
      )}

      {/* ════════════════════════ TAB: DRIVERS ════════════════════════ */}
      {activeTab === 'drivers' && (
        <div className="watrly-tenant-detail__section">
          <div className="watrly-tenant-detail__section-header">
            <h3 className="watrly-tenant-detail__section-title">{I.drivers} السائقين <span className="td-count">{tabTotal}</span></h3>
            <div style={{display:'flex',gap:8}}>
              <Button variant="ghost" size="sm" onClick={loadTabData}>{I.refresh}</Button>
              <Button variant="primary" size="sm" onClick={() => { setShowDriverModal(true); setDriverResult(null); }}>{I.plus} إضافة سائق</Button>
            </div>
          </div>
          <div className="watrly-tenant-detail__section-content">
            <DataTable
              loading={tabLoading}
              rows={tabData}
              emptyIcon={I.drivers}
              emptyText="لا يوجد سائقين حالياً"
              columns={[
                { label: 'السائق', render: (d) => (
                  <div className="td-cell-user">
                    <div className="td-cell-avatar">{d.full_name?.charAt(0) || 'س'}</div>
                    <div><strong>{d.full_name}</strong><br /><span className="td-cell-sub">{d.phone || '-'} • {d.national_id || ''}</span></div>
                  </div>
                )},
                { label: 'الطلبات', render: (d) => formatNum(d.total_orders) },
                { label: 'التقييم', render: (d) => <span className="td-cell-rating">{(d.avg_rating || 5).toFixed(1)}</span> },
                { label: 'الحالة', render: (d) => <StatusBadge active={d.status === 'active'} activeText="نشط" inactiveText="غير نشط" /> },
                { label: 'إجراء', render: (d) => (
                  <div className="td-cell-actions">
                    <button className="td-action-btn td-action-btn--danger" title="إلغاء التفعيل"
                      onClick={() => handleDeleteDriver(d.id, d.full_name)}>{I.trash}</button>
                  </div>
                )},
              ]}
            />
          </div>
        </div>
      )}

      {/* ════════════════════════ TAB: VEHICLES ════════════════════════ */}
      {activeTab === 'vehicles' && (
        <div className="watrly-tenant-detail__section">
          <div className="watrly-tenant-detail__section-header">
            <h3 className="watrly-tenant-detail__section-title">{I.car} المركبات <span className="td-count">{tabTotal}</span></h3>
            <div style={{display:'flex',gap:8}}>
              <Button variant="ghost" size="sm" onClick={loadTabData}>{I.refresh}</Button>
              <Button variant="primary" size="sm" onClick={() => setShowVehicleModal(true)}>{I.plus} إضافة مركبة</Button>
            </div>
          </div>
          <div className="watrly-tenant-detail__section-content">
            <DataTable
              loading={tabLoading}
              rows={tabData}
              emptyIcon={I.car}
              emptyText="لا توجد مركبات حالياً"
              columns={[
                { label: 'المركبة', render: (v) => (
                  <div className="td-cell-user">
                    <div className="td-cell-avatar td-cell-avatar--purple">{I.car}</div>
                    <div><strong>{v.plate_letters} {v.plate_number}</strong><br /><span className="td-cell-sub">{v.make} {v.model}</span></div>
                  </div>
                )},
                { label: 'السعة', render: (v) => `${v.capacity_tons || '-'} طن` },
                { label: 'السائق', render: (v) => v.driver_name || '-' },
                { label: 'الحالة', render: (v) => <StatusBadge active={v.status === 'active'} /> },
                { label: 'إجراء', render: (v) => (
                  <div className="td-cell-actions">
                    <button className="td-action-btn td-action-btn--danger" title="إلغاء التفعيل"
                      onClick={() => handleDeleteVehicle(v.id, `${v.plate_letters} ${v.plate_number}`)}
                    >{I.trash}</button>
                  </div>
                )},
              ]}
            />
          </div>
        </div>
      )}

      {/* ════════════════════════ TAB: PRICING ════════════════════════ */}
      {activeTab === 'pricing' && (
        <div className="watrly-tenant-detail__section">
          <div className="watrly-tenant-detail__section-header">
            <h3 className="watrly-tenant-detail__section-title">{I.dollar} التسعير <span className="td-count">{tabTotal}</span></h3>
            <Button variant="ghost" size="sm" onClick={loadTabData}>{I.refresh}</Button>
          </div>
          <div className="watrly-tenant-detail__section-content">
            <DataTable
              loading={tabLoading}
              rows={tabData}
              emptyIcon={I.dollar}
              emptyText="لا توجد تسعيرات حالياً"
              columns={[
                { label: 'التسعيرة', render: (p) => (
                  <div className="td-cell-user">
                    <div className="td-cell-avatar td-cell-avatar--amber">{I.dollar}</div>
                    <div><strong>{p.name}</strong></div>
                  </div>
                )},
                { label: 'سعر الطن', render: (p) => <Money n={p.base_price_per_ton} /> },
                { label: 'سعر/كم', render: (p) => <Money n={p.price_per_km} /> },
                { label: 'الضريبة', render: (p) => `${p.tax_rate || 0}%` },
                { label: 'الذروة', render: (p) => <StatusBadge active={p.surge_enabled} activeText="مفعّلة" inactiveText="معطلة" /> },
              ]}
            />
          </div>
        </div>
      )}

      {/* ════════════════════════ TAB: COUPONS ════════════════════════ */}
      {activeTab === 'coupons' && (
        <div className="watrly-tenant-detail__section">
          <div className="watrly-tenant-detail__section-header">
            <h3 className="watrly-tenant-detail__section-title">{I.tag} الكوبونات <span className="td-count">{tabTotal}</span></h3>
            <Button variant="ghost" size="sm" onClick={loadTabData}>{I.refresh}</Button>
          </div>
          <div className="watrly-tenant-detail__section-content">
            <DataTable
              loading={tabLoading}
              rows={tabData}
              emptyIcon={I.tag}
              emptyText="لا توجد كوبونات حالياً"
              columns={[
                { label: 'الكوبون', render: (c) => (
                  <div className="td-cell-user">
                    <div className="td-cell-avatar td-cell-avatar--pink">{I.tag}</div>
                    <div><strong>{c.code}</strong><br /><span className="td-cell-sub">{c.description || '-'}</span></div>
                  </div>
                )},
                { label: 'الخصم', render: (c) => {
                  const val = c.discount_value_override ?? c.discount_value ?? null;
                  if (val === null) return '-';
                  return c.discount_type === 'percentage' ? `${val}%` : <Money n={val} />;
                }},
                { label: 'الحد الأقصى', render: (c) => c.max_discount_amount ? <Money n={c.max_discount_amount} /> : '∞' },
                { label: 'الاستخدام', render: (c) => `${c.redemption_count ?? c.usage_count ?? 0} / ${c.max_redemptions ?? '∞'}` },
                { label: 'الانتهاء', render: (c) => c.expires_at ? new Date(c.expires_at).toLocaleDateString('ar-SA') : 'لا يوجد' },
                { label: 'الحالة', render: (c) => <StatusBadge active={c.is_active} activeText="نشط" inactiveText="منتهي" /> },
              ]}
            />
          </div>
        </div>
      )}

      {/* ════════════════════════ TAB: REPORTS ════════════════════════ */}
      {activeTab === 'reports' && (
        <div className="watrly-tenant-detail__section">
          <div className="watrly-tenant-detail__section-header">
            <h3 className="watrly-tenant-detail__section-title">{I.chart} التقارير والإحصائيات</h3>
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
              <select
                className="td-select"
                value={reportPeriod}
                onChange={(e) => setReportPeriod(e.target.value)}
              >
                <option value="7d">آخر 7 أيام</option>
                <option value="30d">آخر 30 يوم</option>
                <option value="90d">آخر 3 أشهر</option>
                <option value="1y">آخر سنة</option>
              </select>
            </div>
          </div>
          <div className="watrly-tenant-detail__section-content">
            {tabLoading ? (
              <div className="td-table-empty"><div className="watrly-admin-loading__spinner" /></div>
            ) : (
              <>
                <div className="td-report-grid">
                  {[
                    { label: 'إجمالي قيمة الطلبات', value: <Money n={reportStats?.orders?.total_revenue ?? 0} />, color: '#10B981', bg: '#F0FDF4' },
                    { label: 'إيرادات الطلب (مياه)', value: <Money n={reportStats?.orders?.order_revenue ?? 0} />, color: '#0EA5E9', bg: '#F0F9FF', hint: 'السعر - الخصم + الضريبة' },
                    { label: 'إيرادات التوصيل', value: <Money n={reportStats?.orders?.delivery_revenue ?? 0} />, color: '#8B5CF6', bg: '#F5F3FF', hint: 'حصة السائق/المقاول' },
                    { label: 'إجمالي الطلبات', value: formatNum(reportStats?.orders?.total_orders ?? 0), color: '#3B82F6', bg: '#EFF6FF' },
                    { label: 'تم التوصيل', value: formatNum(reportStats?.orders?.completed_orders ?? 0), color: '#059669', bg: '#ECFDF5' },
                    { label: 'ملغية', value: formatNum(reportStats?.orders?.cancelled_orders ?? 0), color: '#EF4444', bg: '#FEF2F2' },
                    { label: 'السائقين النشطين', value: formatNum(reportStats?.drivers?.active_drivers ?? stats.drivers_count), color: '#F59E0B', bg: '#FEF3C7' },
                    { label: 'العملاء', value: formatNum(reportStats?.customers?.unique_customers ?? reportStats?.customers?.total_customers ?? 0), color: '#EC4899', bg: '#FDF2F8' },
                    { label: 'متوسط قيمة الطلب', value: <Money n={reportStats?.orders?.avg_order_value ?? 0} />, color: '#6366F1', bg: '#EEF2FF' },
                    { label: 'الضريبة', value: <Money n={reportStats?.orders?.total_tax ?? 0} />, color: '#64748B', bg: '#F8FAFC' },
                    { label: 'الخصومات', value: <Money n={reportStats?.orders?.total_discount ?? 0} />, color: '#F97316', bg: '#FFF7ED' },
                  ].map((item, i) => (
                    <div key={i} className="td-report-card" style={{ background: item.bg }}>
                      <span className="td-report-card__value" style={{ color: item.color }}>{item.value}</span>
                      <span className="td-report-card__label">{item.label}</span>
                      {item.hint && <span style={{fontSize:'0.68rem',color:'#94A3B8',marginTop:2}}>{item.hint}</span>}
                    </div>
                  ))}
                </div>
                <div className="td-report-actions">
                  <Button variant="ghost" size="sm" onClick={() => handleExportReport('orders')}>{I.download} تقرير الطلبات</Button>
                  <Button variant="ghost" size="sm" onClick={() => handleExportReport('revenue')}>{I.download} تقرير الإيرادات</Button>
                  <Button variant="ghost" size="sm" onClick={() => handleExportReport('drivers')}>{I.download} تقرير السائقين</Button>
                  <Button variant="ghost" size="sm" onClick={() => handleExportReport('customers')}>{I.download} تقرير العملاء</Button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* ════════════════════════ TAB: SETTINGS ════════════════════════ */}
      {activeTab === 'settings' && (
        <div className="watrly-tenant-detail__section">
          <div className="watrly-tenant-detail__section-header">
            <h3 className="watrly-tenant-detail__section-title">{I.settings} إعدادات الشركة</h3>
            <Button variant="primary" size="sm" onClick={() => setShowEditModal(true)}>{I.edit} تعديل الإعدادات</Button>
          </div>
          <div className="watrly-tenant-detail__section-content">
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:'1rem'}}>
              {[
                { icon: '📦', title: 'الباقة', value: tenant.plan_code === 'enterprise' ? 'مؤسسات' : tenant.plan_code === 'business' ? 'أعمال' : 'أساسي', color: '#6366F1' },
                { icon: '🌍', title: 'المنطقة الزمنية', value: tenant.timezone || 'Asia/Riyadh', color: '#3B82F6' },
                { icon: '💱', title: 'العملة', value: tenant.default_currency_code || 'SAR', color: '#10B981' },
                { icon: '🧾', title: 'ضريبة القيمة المضافة', value: `${tenant.tax_rate ?? 15}%`, color: '#F59E0B' },
                { icon: '📍', title: 'أقصى مسافة خدمة', value: tenant.max_service_distance_km ? `${tenant.max_service_distance_km} كم` : 'غير محدد', color: '#EF4444' },
                { icon: '🚗', title: 'سعر/كم', value: tenant.price_per_km ? `${tenant.price_per_km} ريال` : 'غير محدد', color: '#8B5CF6' },
                { icon: '⏱️', title: 'سعر/15 دقيقة', value: tenant.price_per_15min ? `${tenant.price_per_15min} ريال` : 'غير محدد', color: '#EC4899' },
                { icon: '💰', title: 'نسبة العمولة', value: tenant.commission_rate != null ? `${tenant.commission_rate}%` : 'غير محدد', color: '#14B8A6' },
                { icon: '🏦', title: 'الرسوم الشهرية', value: tenant.monthly_fee ? `${tenant.monthly_fee} ريال` : 'غير محدد', color: '#F97316' },
                { icon: '📅', title: 'بداية الاشتراك', value: tenant.subscription_start_date ? formatDate(tenant.subscription_start_date) : 'غير محدد', color: '#6366F1' },
                { icon: '📅', title: 'نهاية الاشتراك', value: tenant.subscription_end_date ? formatDate(tenant.subscription_end_date) : 'غير محدد', color: '#EF4444' },
              ].map((item, i) => (
                <div key={i} style={{background:'#F8FAFC',borderRadius:12,padding:'1rem',border:'1px solid #E2E8F0',display:'flex',gap:'0.75rem',alignItems:'center'}}>
                  <span style={{fontSize:'1.5rem'}}>{item.icon}</span>
                  <div>
                    <div style={{fontSize:'0.75rem',color:'#64748B',marginBottom:2}}>{item.title}</div>
                    <div style={{fontWeight:600,color:item.color,fontSize:'0.95rem'}}>{item.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ═══════════════ MODALS ═══════════════ */}

      {/* Edit Tenant */}
      <Modal isOpen={showEditModal} onClose={() => setShowEditModal(false)} title="تعديل بيانات الشركة" size="lg"
        footer={<div className="td-modal-footer"><Button variant="ghost" onClick={() => setShowEditModal(false)}>إلغاء</Button><Button variant="primary" onClick={handleUpdateTenant} loading={saving}>حفظ التغييرات</Button></div>}
      >
        <div className="td-modal-stack">
          <p style={{fontWeight:600,color:'#6366F1',borderBottom:'1px solid #e5e7eb',paddingBottom:8}}>البيانات الأساسية</p>
          <div className="td-modal-grid">
            <Input label="اسم الشركة" value={editData.name || ''} onChange={(e) => setEditData({ ...editData, name: e.target.value })} />
            <Input label="المعرف (Slug)" value={editData.slug || ''} onChange={(e) => setEditData({ ...editData, slug: e.target.value })} />
            <div className="td-form-group"><label className="td-form-label">الباقة</label>
              <select className="td-select" value={editData.plan_code || 'basic'} onChange={(e) => setEditData({ ...editData, plan_code: e.target.value })}>
                <option value="basic">أساسي</option><option value="business">أعمال</option><option value="enterprise">مؤسسات</option>
              </select></div>
            <div className="td-form-group"><label className="td-form-label">الحالة</label>
              <select className="td-select" value={editData.status || 'active'} onChange={(e) => setEditData({ ...editData, status: e.target.value })}>
                <option value="active">نشط</option><option value="suspended">معلق</option>
              </select></div>
            <div className="td-form-group"><label className="td-form-label">المنطقة الزمنية</label>
              <select className="td-select" value={editData.timezone || 'Asia/Riyadh'} onChange={(e) => setEditData({ ...editData, timezone: e.target.value })}>
                <option value="Asia/Riyadh">الرياض (GMT+3)</option><option value="Asia/Dubai">دبي (GMT+4)</option><option value="Asia/Kuwait">الكويت (GMT+3)</option><option value="Africa/Cairo">القاهرة (GMT+2)</option>
              </select></div>
            <div className="td-form-group"><label className="td-form-label">العملة</label>
              <select className="td-select" value={editData.default_currency_code || 'SAR'} onChange={(e) => setEditData({ ...editData, default_currency_code: e.target.value })}>
                <option value="SAR">ريال سعودي (SAR)</option><option value="AED">درهم إماراتي (AED)</option><option value="KWD">دينار كويتي (KWD)</option><option value="EGP">جنيه مصري (EGP)</option>
              </select></div>
          </div>
          <p style={{fontWeight:600,color:'#10B981',borderBottom:'1px solid #e5e7eb',paddingBottom:8,marginTop:8}}>بيانات التواصل والعنوان</p>
          <div className="td-modal-grid">
            <Input label="رقم التواصل" value={editData.contact_phone || ''} onChange={(e) => setEditData({ ...editData, contact_phone: e.target.value })} />
            <Input label="البريد الإلكتروني" type="email" value={editData.contact_email || ''} onChange={(e) => setEditData({ ...editData, contact_email: e.target.value })} />
            <Input label="المدينة" value={editData.city || ''} onChange={(e) => setEditData({ ...editData, city: e.target.value })} />
            <Input label="المنطقة" value={editData.region || ''} onChange={(e) => setEditData({ ...editData, region: e.target.value })} />
            <Input label="الدولة" value={editData.country || ''} onChange={(e) => setEditData({ ...editData, country: e.target.value })} />
            <Input label="العنوان" value={editData.address || ''} onChange={(e) => setEditData({ ...editData, address: e.target.value })} />
          </div>
          <p style={{fontWeight:600,color:'#F59E0B',borderBottom:'1px solid #e5e7eb',paddingBottom:8,marginTop:8}}>البيانات التجارية والمالية</p>
          <div className="td-modal-grid">
            <Input label="السجل التجاري" value={editData.commercial_registration || ''} onChange={(e) => setEditData({ ...editData, commercial_registration: e.target.value })} />
            <Input label="الرقم الضريبي (VAT)" value={editData.vat_number || ''} onChange={(e) => setEditData({ ...editData, vat_number: e.target.value })} />
            <Input label="اسم البنك" value={editData.bank_name || ''} onChange={(e) => setEditData({ ...editData, bank_name: e.target.value })} />
            <Input label="رقم الحساب" value={editData.bank_account || ''} onChange={(e) => setEditData({ ...editData, bank_account: e.target.value })} />
            <Input label="IBAN" value={editData.iban || ''} onChange={(e) => setEditData({ ...editData, iban: e.target.value })} />
            <Input label="نسبة العمولة %" type="number" value={editData.commission_rate ?? ''} onChange={(e) => setEditData({ ...editData, commission_rate: e.target.value })} />
            <Input label="الرسوم الشهرية (SAR)" type="number" value={editData.monthly_fee ?? ''} onChange={(e) => setEditData({ ...editData, monthly_fee: e.target.value })} />
            <Input label="ضريبة القيمة المضافة %" type="number" value={editData.tax_rate ?? 15} onChange={(e) => setEditData({ ...editData, tax_rate: e.target.value })} />
          </div>
          <p style={{fontWeight:600,color:'#8B5CF6',borderBottom:'1px solid #e5e7eb',paddingBottom:8,marginTop:8}}>إعدادات التسعير</p>
          <div className="td-modal-grid">
            <Input label="سعر/كم (SAR)" type="number" value={editData.price_per_km ?? ''} onChange={(e) => setEditData({ ...editData, price_per_km: e.target.value })} />
            <Input label="سعر/15 دقيقة (SAR)" type="number" value={editData.price_per_15min ?? ''} onChange={(e) => setEditData({ ...editData, price_per_15min: e.target.value })} />
            <Input label="أقصى مسافة خدمة (كم)" type="number" value={editData.max_service_distance_km ?? ''} onChange={(e) => setEditData({ ...editData, max_service_distance_km: e.target.value })} />
          </div>
        </div>
      </Modal>

      {/* Edit User */}
      <Modal isOpen={showUserModal} onClose={() => { setShowUserModal(false); setSelectedUser(null); }} title={`تعديل: ${selectedUser?.full_name || ''}`} size="md"
        footer={<div className="td-modal-footer"><Button variant="ghost" onClick={() => setShowUserModal(false)}>إلغاء</Button><Button variant="primary" onClick={handleUpdateUser} loading={saving}>حفظ</Button></div>}
      >
        <div className="td-modal-stack">
          <Input label="الاسم الكامل" value={userFormData.full_name || ''} onChange={(e) => setUserFormData({ ...userFormData, full_name: e.target.value })} />
          <Input label="البريد الإلكتروني" type="email" value={userFormData.email || ''} onChange={(e) => setUserFormData({ ...userFormData, email: e.target.value })} />
          <Input label="رقم الهاتف" value={userFormData.phone || ''} onChange={(e) => setUserFormData({ ...userFormData, phone: e.target.value })} />
          <div className="td-form-group">
            <label className="td-form-label">الحالة</label>
            <select className="td-select" value={userFormData.status || 'active'} onChange={(e) => setUserFormData({ ...userFormData, status: e.target.value })}>
              <option value="active">نشط</option><option value="suspended">معلق</option>
            </select>
          </div>
        </div>
      </Modal>

      {/* Change Password */}
      <Modal isOpen={showPasswordModal} onClose={() => { setShowPasswordModal(false); setSelectedUser(null); }} title={`تغيير كلمة مرور: ${selectedUser?.full_name || ''}`} size="sm"
        footer={<div className="td-modal-footer"><Button variant="ghost" onClick={() => setShowPasswordModal(false)}>إلغاء</Button><Button variant="primary" onClick={handleUpdatePassword} loading={saving}>تغيير</Button></div>}
      >
        <div className="td-modal-stack">
          <Input label="كلمة المرور الجديدة" type="password" value={passwordData.password} onChange={(e) => setPasswordData({ ...passwordData, password: e.target.value })} />
          <Input label="تأكيد كلمة المرور" type="password" value={passwordData.confirmPassword} onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })} />
        </div>
      </Modal>

      {/* Delete User */}
      <Modal isOpen={showDeleteUserModal} onClose={() => { setShowDeleteUserModal(false); setSelectedUser(null); }} title="تأكيد حذف المستخدم" size="sm"
        footer={<div className="td-modal-footer"><Button variant="ghost" onClick={() => setShowDeleteUserModal(false)}>إلغاء</Button><Button variant="danger" onClick={handleDeleteUser} loading={saving}>حذف</Button></div>}
      >
        <div className="td-confirm-msg">
          <p>هل أنت متأكد من حذف المستخدم <strong>{selectedUser?.full_name}</strong>؟</p>
          <p className="td-confirm-warn">هذا الإجراء لا يمكن التراجع عنه</p>
        </div>
      </Modal>

      {/* ─── Ship Approve Modal ─── */}
      {shipApprove && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}} onClick={() => setShipApprove(null)}>
          <div style={{background:'#fff',borderRadius:16,padding:28,width:'100%',maxWidth:440,boxShadow:'0 20px 60px rgba(0,0,0,.2)'}} onClick={e=>e.stopPropagation()}>
            <h3 style={{margin:'0 0 8px',fontSize:18,fontWeight:700}}>قبول الشيب</h3>
            <p style={{margin:'0 0 16px',fontSize:13,color:'#64748b'}}>الشيب: <strong>{shipApprove.name}</strong></p>
            <div style={{marginBottom:16}}>
              <label style={{display:'block',fontSize:13,fontWeight:600,marginBottom:6}}>ملاحظات (اختياري)</label>
              <textarea value={shipNotes} onChange={e=>setShipNotes(e.target.value)} rows={3}
                style={{width:'100%',border:'1px solid #e2e8f0',borderRadius:8,padding:'8px 12px',fontSize:13,fontFamily:'inherit',resize:'vertical',boxSizing:'border-box',direction:'rtl'}}
                placeholder="أي ملاحظات للشركة..." />
            </div>
            <div style={{background:'#eff6ff',border:'1px solid #bfdbfe',borderRadius:8,padding:'10px 14px',fontSize:12,color:'#1d4ed8',marginBottom:16}}>
              سيصبح الشيب نشطاً ومقبولاً ويستقبل الطلبات فوراً.
            </div>
            <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
              <Button variant="ghost" onClick={() => setShipApprove(null)}>إلغاء</Button>
              <Button variant="success" onClick={handleApproveShip} loading={actioning}>✓ تأكيد القبول</Button>
            </div>
          </div>
        </div>
      )}

      {/* ─── Ship Reject Modal ─── */}
      {shipReject && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}} onClick={() => setShipReject(null)}>
          <div style={{background:'#fff',borderRadius:16,padding:28,width:'100%',maxWidth:440,boxShadow:'0 20px 60px rgba(0,0,0,.2)'}} onClick={e=>e.stopPropagation()}>
            <h3 style={{margin:'0 0 8px',fontSize:18,fontWeight:700}}>رفض الشيب</h3>
            <p style={{margin:'0 0 16px',fontSize:13,color:'#64748b'}}>الشيب: <strong>{shipReject.name}</strong></p>
            <div style={{marginBottom:16}}>
              <label style={{display:'block',fontSize:13,fontWeight:600,marginBottom:6}}>سبب الرفض <span style={{color:'#ef4444'}}>*</span></label>
              <textarea value={shipReason} onChange={e=>setShipReason(e.target.value)} rows={3}
                style={{width:'100%',border:'1px solid #e2e8f0',borderRadius:8,padding:'8px 12px',fontSize:13,fontFamily:'inherit',resize:'vertical',boxSizing:'border-box',direction:'rtl'}}
                placeholder="اذكر سبب الرفض بوضوح..." />
            </div>
            <div style={{background:'#fff7ed',border:'1px solid #fed7aa',borderRadius:8,padding:'10px 14px',fontSize:12,color:'#9a3412',marginBottom:16}}>
              سيتم إيقاف الشيب ولن يستقبل طلبات. يمكن قبوله لاحقاً.
            </div>
            <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
              <Button variant="ghost" onClick={() => setShipReject(null)}>إلغاء</Button>
              <Button variant="danger" onClick={handleRejectShip} loading={actioning}>✕ تأكيد الرفض</Button>
            </div>
          </div>
        </div>
      )}

      {/* ─── Add Driver Modal ─── */}
      <Modal isOpen={showDriverModal} onClose={() => { setShowDriverModal(false); setDriverResult(null); }} title="إضافة سائق جديد" size="md"
        footer={<div className="td-modal-footer">
          <Button variant="ghost" onClick={() => { setShowDriverModal(false); setDriverResult(null); }}>إغلاق</Button>
          {!driverResult && <Button variant="primary" onClick={handleCreateDriver} loading={saving}>إضافة</Button>}
        </div>}
      >
        {driverResult ? (
          <div style={{textAlign:'center',padding:'16px 0'}}>
            <div style={{fontSize:40,marginBottom:12}}>✅</div>
            <p style={{fontWeight:700,fontSize:16}}>تم إضافة السائق بنجاح!</p>
            <div style={{background:'#f0fdf4',border:'1px solid #86efac',borderRadius:10,padding:'12px 16px',marginTop:12,textAlign:'right',direction:'rtl'}}>
              <p style={{margin:'0 0 6px',fontSize:13}}><strong>كلمة المرور المؤقتة:</strong></p>
              <code style={{fontSize:18,fontWeight:700,color:'#15803d',letterSpacing:2}}>{driverResult.temp_password}</code>
              <p style={{margin:'8px 0 0',fontSize:11,color:'#64748b'}}>احفظها الآن — لن تُعرض مرة أخرى</p>
            </div>
          </div>
        ) : (
          <div className="td-modal-stack">
            <Input label="الاسم الكامل" value={driverForm.full_name} onChange={e => setDriverForm({...driverForm, full_name: e.target.value})} required />
            <Input label="رقم الهاتف" value={driverForm.phone} onChange={e => setDriverForm({...driverForm, phone: e.target.value})} required />
            <Input label="رقم الهوية" value={driverForm.national_id} onChange={e => setDriverForm({...driverForm, national_id: e.target.value})} />
          </div>
        )}
      </Modal>

      {/* ─── Add Vehicle Modal ─── */}
      <Modal isOpen={showVehicleModal} onClose={() => setShowVehicleModal(false)} title="إضافة مركبة جديدة" size="md"
        footer={<div className="td-modal-footer">
          <Button variant="ghost" onClick={() => setShowVehicleModal(false)}>إلغاء</Button>
          <Button variant="primary" onClick={handleCreateVehicle} loading={saving}>إضافة</Button>
        </div>}
      >
        <div className="td-modal-grid">
          <Input label="أحرف اللوحة" value={vehicleForm.plate_letters} onChange={e => setVehicleForm({...vehicleForm, plate_letters: e.target.value})} placeholder="أ ب ج" />
          <Input label="أرقام اللوحة" value={vehicleForm.plate_number} onChange={e => setVehicleForm({...vehicleForm, plate_number: e.target.value})} placeholder="1234" required />
          <Input label="الماركة" value={vehicleForm.make} onChange={e => setVehicleForm({...vehicleForm, make: e.target.value})} placeholder="تويوتا" />
          <Input label="الموديل" value={vehicleForm.model} onChange={e => setVehicleForm({...vehicleForm, model: e.target.value})} placeholder="هايلوكس" />
          <Input label="السعة (طن)" type="number" value={vehicleForm.capacity_tons} onChange={e => setVehicleForm({...vehicleForm, capacity_tons: e.target.value})} placeholder="5" />
        </div>
      </Modal>

      {/* Delete Tenant */}
      <Modal isOpen={showDeleteModal} onClose={() => setShowDeleteModal(false)} title="تأكيد حذف الشركة" size="sm"
        footer={<div className="td-modal-footer"><Button variant="ghost" onClick={() => setShowDeleteModal(false)}>إلغاء</Button><Button variant="danger" onClick={handleDeleteTenant} loading={saving}>حذف</Button></div>}
      >
        <div className="td-confirm-msg">
          <p>هل أنت متأكد من حذف شركة <strong>{tenant.name}</strong>؟</p>
          <p className="td-confirm-warn">هذا الإجراء لا يمكن التراجع عنه وسيتم حذف جميع البيانات المرتبطة</p>
        </div>
      </Modal>
    </div>
  );
};

export default TenantDetailPage;
